// @flow

import styled, { css } from 'styled-components';
import media from '../../../../helpers/media';
import { LIGHT } from '../../../../helpers/fontWeight';
import type { Limits } from '../../types';
import type { Theme } from '../../../../types';

export const collapsedListItem = (limits: Limits, collapsed: boolean) => css`
  ${collapsed && css`
    display: none;
    ${typeof limits === 'number' ? css`
      &:nth-child(-n+${limits}) {
        display: inherit;
      }
    ` : css`
    &:nth-child(-n+${limits.default}) {
      display: inherit;
    }

    ${media.sm(css`
      &:nth-child(-n+${limits.sm}) {
        display: inherit;
      }
    `)};
    ${media.md(css`
      &:nth-child(-n+${limits.md}) {
        display: inherit;
      }
    `)};
    ${media.lg(css`
      &:nth-child(-n+${limits.lg}) {
        display: inherit;
      }
    `)};
    ${media.xl(css`
      &:nth-child(-n+${limits.xl}) {
        display: inherit;
      }
    `)};`}
  `}
`;

export const ListItemContainer = styled<any, Theme>('section')`
  box-sizing: border-box;
  display: flex;
`;

export const ListItemIcon = styled<any, Theme>('div')`
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
`;

export const ListItemContent = styled<any, Theme>('div')`
  box-sizing: border-box;
  display: flex;
  padding-left: 1.25rem;
`;

const getPaddingBottom = type => {
  switch (type) {
    case 'bullets':
      return '.5rem';

    case 'numbered':
      return '1.25rem';

    default:
      return '1rem';
  }
};

type Props = {
  type: string,
  minimalistic: boolean,
  limit: Limits,
  collapsed: boolean,
};

const ListItemComponent = styled<any, Theme, Props>('li')`
  position: relative;
  font-size: 1rem;
  ${media.md(css`
    font-size: ${({ theme }) => theme.list.fontSize};
  `)};
  font-weight: ${LIGHT};
  padding-bottom: ${({ type }) => getPaddingBottom(type)};
  padding-right: 1.5em;

  &:last-child {
    border-bottom: 0;
  }

  ${({ minimalistic }) => minimalistic && css`
    &:first-child {
      padding-top: 1em;
    }
  `}
  ${({ limit, collapsed }) => collapsedListItem(limit, collapsed)}
`;

export default ListItemComponent;
